import React from 'react';
import { string, func, bool } from 'prop-types';
import { get, includes } from 'lodash';
import { Row, If, Column, Text, Icon, InfoTag } from '../../common';
import { Switch, Divider } from 'antd';

const messages = {
    true: {
        strong: 'Validación de peso rechazada. ',
        regular: 'Verifica junto al shopper que el total de unidades por producto en el carro está correcto antes de aprobar la auditoría.',
        switchable: true
    },
    false: {
        strong: 'Validación de peso aprobada.',
        regular: '',
        switchable: false
    }
};

const WeightValidation = ({ weightError, semaphore, callback, isHistory }) => {
    const error = {
        msg: get(messages, `${weightError}.strong`),
        tail: get(messages, `${weightError}.regular`),
        color: '#BD2C00',
        icon: 'alert-circle',
        bgColor: '#F7E6E1',
        borderColor: '#BD2C00'
    };
    
    const success = {
        msg: get(messages, `${weightError}.strong`),
        tail: get(messages, `${weightError}.regular`),
        color: '#22A889',
        icon: 'checkmark-circle',
        bgColor: '#E6F5F1',
        borderColor: '#B6DFD6'
    };

    const getColorAndTextSemaphore = (type) => {
        if (type === 'small') return { color: '#1fa02e', text: 'Baja', backgroundColor: '#E6F5F1' };
        if (type === 'medium') return { color: '#EB963C', text: 'Media', backgroundColor: 'rgb(255, 242, 208)' };
        if (type === 'large') return { color: '#cc2c3b', text: 'Alta', backgroundColor: '#f9e6e8' };
    }
    
    const { msg, tail, bgColor, icon, color, borderColor } = weightError === 'true' ? error : success;
    const semaphoreStyles = getColorAndTextSemaphore(semaphore);

    return (
        <If
            condition={includes(['true', 'false'], weightError)}
            then={
                <Row backgroundColor='#f4f4f4' style={{ borderTop: '1px solid #eaeaea' }}>
                    <Column padding={10} direction='row' align='center'>
                        <Row align='center' style={{ backgroundColor: bgColor, border: `1px solid ${borderColor}`, borderRadius: 8, padding: '9px 12px' }}>
                            <Column direction='row'  maxWidth={60}>
                                <Icon name={icon} size={24} color={color} />
                                <Divider type='vertical' style={{ background: color, height: '1.5em', margin: '0px 16px 0px 14px' }} />
                            </Column>
                            <Column direction='row' flex={10}>
                                <Text text={msg} size={12} color='#323A44' strong />
                                {!isHistory && <Text text={tail} size={12} color='#323A44' />}
                            </Column>
                        </Row>
                    </Column>
                    <Column justify='center' maxWidth={140} padding={10}>
                        <Row align='center'>
                            {semaphore && <>
                                    <Text text={'Desviación:'} />
                                    <InfoTag background={semaphoreStyles.backgroundColor} style={{ border: `1px solid ${semaphoreStyles.color}`, padding: '1px 10px' }}>
                                        <Text  text={semaphoreStyles.text} color={semaphoreStyles.color} size={12} />
                                    </InfoTag>
                            </>}
                        </Row>
                    </Column>
                    <If
                        condition={!isHistory && get(messages, `${weightError}.switchable`)}
                        then={
                            <Column justify='center' maxWidth={100} padding={10}>
                                <Switch
                                    checkedChildren='Aprobar'
                                    unCheckedChildren='Rechazar'
                                    onChange={callback}
                                />
                            </Column>
                        }
                    />
                </Row>
            }
        />
    );
};

WeightValidation.propTypes = {
    weightError: string,
    callback: func,
    isHistory: bool
};

WeightValidation.defaultProps = {
    weightError: 'null',
    semaphore: null,
    callback: () => {},
    isHistory: false 
};

export default WeightValidation;
